var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxtf-popover",
        {
          staticClass:
            "mv24 ml32 hand d-in-block text-26 o20-myteam-content_sel_team",
          attrs: {
            "popper-class": "team-select-self-height",
            placement: "bottom-start",
            trigger: "manual",
            lazy: "true",
            effect: "",
          },
          model: {
            value: _vm.showTeamSel,
            callback: function ($$v) {
              _vm.showTeamSel = $$v
            },
            expression: "showTeamSel",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "100%" } },
            [
              _c("yxtf-tree", {
                attrs: {
                  "node-key": "teamId",
                  "popper-class": "team-pop",
                  lazy: "",
                  load: _vm.loadNode,
                  props: _vm.teamProps,
                  "expand-on-click-node": false,
                },
                on: { "node-click": _vm.handleTeamNodeClick },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "standard-size-20",
              attrs: { slot: "reference" },
              on: {
                click: function ($event) {
                  _vm.showTeamSel = _vm.isShowTeamSel
                    ? !_vm.showTeamSel
                    : _vm.showTeamSel
                },
              },
              slot: "reference",
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.selTeamName))]),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowTeamSel,
                    expression: "isShowTeamSel",
                  },
                ],
                staticClass: "ml3 standard-size-16",
                class: _vm.showTeamSel
                  ? "yxt-icon-arrow-up"
                  : "yxt-icon-arrow-down",
              }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }